var _defs, _rect, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 816,
    zoomAndPan: "magnify",
    viewBox: "0 0 612 791.999994",
    height: 1056,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "28c79cb4e1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.996094 228.996094 L 472.746094 228.996094 L 472.746094 562.746094 L 138.996094 562.746094 Z M 138.996094 228.996094 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -61.2,
    width: 734.4,
    fill: "#ffffff",
    y: -79.199999,
    height: 950.399992,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 349.453125 299.992188 L 262.429688 299.992188 C 233.609375 299.992188 210.132812 323.46875 210.132812 352.289062 L 210.132812 439.3125 C 210.132812 468.132812 233.609375 491.609375 262.429688 491.609375 L 349.453125 491.609375 C 378.273438 491.609375 401.75 468.132812 401.75 439.3125 L 401.75 352.429688 C 401.75 323.46875 378.273438 299.992188 349.453125 299.992188 Z M 385.300781 439.453125 C 385.300781 459.273438 369.273438 475.300781 349.453125 475.300781 L 262.429688 475.300781 C 242.609375 475.300781 226.441406 459.273438 226.441406 439.453125 L 226.441406 352.429688 C 226.441406 332.609375 242.609375 316.441406 262.429688 316.441406 L 349.453125 316.441406 C 369.273438 316.441406 385.300781 332.46875 385.300781 352.429688 Z M 385.300781 439.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 369.976562 343.433594 C 369.976562 349.898438 364.777344 355.242188 358.167969 355.242188 C 351.703125 355.242188 346.359375 350.039062 346.359375 343.433594 C 346.359375 336.964844 351.5625 331.625 358.167969 331.625 C 364.777344 331.765625 369.976562 336.964844 369.976562 343.433594 Z M 369.976562 343.433594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 305.871094 347.085938 C 279.019531 347.085938 257.085938 369.019531 257.085938 395.871094 C 257.085938 422.722656 279.019531 444.652344 305.871094 444.652344 C 332.722656 444.652344 354.652344 422.722656 354.652344 395.871094 C 354.652344 369.019531 332.863281 347.085938 305.871094 347.085938 Z M 305.871094 428.207031 C 288.015625 428.207031 273.535156 413.726562 273.535156 395.871094 C 273.535156 378.015625 288.015625 363.535156 305.871094 363.535156 C 323.726562 363.535156 338.207031 378.015625 338.207031 395.871094 C 338.207031 413.726562 323.726562 428.207031 305.871094 428.207031 Z M 305.871094 428.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#28c79cb4e1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 305.871094 562.746094 C 213.929688 562.746094 138.996094 487.953125 138.996094 395.871094 C 138.996094 303.929688 213.929688 228.996094 305.871094 228.996094 C 397.953125 228.996094 472.746094 303.929688 472.746094 395.871094 C 472.746094 487.953125 397.953125 562.746094 305.871094 562.746094 Z M 305.871094 238.132812 C 218.847656 238.132812 148.132812 308.847656 148.132812 395.871094 C 148.132812 482.894531 218.847656 553.609375 305.871094 553.609375 C 392.894531 553.609375 463.609375 482.894531 463.609375 395.871094 C 463.609375 308.847656 392.894531 238.132812 305.871094 238.132812 Z M 305.871094 238.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.315f7e797f332fd1b5cf8d694d2d6b54.svg";
export { ForwardRef as ReactComponent };